import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';

import Button from '../../components/ui/Button';
import InputField from '../../components/ui/InputField';
import AuthLayout from '../../layout/AuthLayout';
import {pageRoutes} from '../../routes';
import * as yup from 'yup';
import {toast} from 'react-hot-toast';
import {useForgotPassword} from '../../api/auth';

const valdiationSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter valid email')
    .required('Email is required'),
});

const ForgotPassword = AuthLayout(() => {
  const navigate = useNavigate();
  const forgotPasswordMutation = useForgotPassword();

  const {
    register,
    handleSubmit,
    reset,
    formState: {errors},
  } = useForm({
    mode: 'all',
    resolver: yupResolver(valdiationSchema),
  });

  const handleForgotPasswordSuccess = () => {
    toast.success('password reset link has been sent.');
    reset();
    navigate('/');
  };

  const handleFormSubmission = (values) => {
    const forgotPasswordPayload = {
      ...values,
      role: 'admin',
    };

    forgotPasswordMutation.mutate(forgotPasswordPayload, {
      onSuccess: handleForgotPasswordSuccess,
      onError: (data) => toast.error(data.response.data.message),
    });
  };

  return (
    <>
      <h2 className="text-primary-main text-3xl font-bold text-center">
        Forgot password
      </h2>
      <form
        className="mt-10 mb-7"
        onSubmit={handleSubmit(handleFormSubmission)}
      >
        <div className="flex items-center mb-3">
          <label className="w-1/3 text-center font-semibold">Email</label>
          <InputField
            {...register('email', {required: true})}
            placeholder="email"
            error={errors?.email?.message}
            fullWidth
          />
        </div>
        <Button
          variant="flat"
          onClick={() => navigate(pageRoutes.login)}
          className="block ml-auto text-sm text-primary-main"
        >
          Go to Login
        </Button>
        <Button className="block mx-auto" type="submit">
          Send an Email
        </Button>
      </form>
    </>
  );
});

export default ForgotPassword;
